import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  Tabs,
  Tab,
  Box,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Tooltip,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

import { url } from "../../constant";

function FormSettings() {
  const [tab, setTab] = useState(0);
  const [formState, setFormState] = useState(null);
  const [formItem, setFormItem] = useState({ id: null, title: "", content: "" });
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [currentPageIndex, setCurrentPageIndex] = useState(0); // Manage pagination state

  useEffect(() => {
    fetchFormItem();
  }, []);

  const fetchFormItem = async () => {
  setLoading(true);
  try {
    const res = await fetch(`${url}auth/contact-form-content`);
    if (!res.ok) throw new Error(`Error: ${res.status}`);

    const data = await res.json();
    setFormItem({
      id: data.id,
      title: data.title,
      content: data.content,
    });
    setFormState({ title: data.title, content: data.content }); // set form for editing
    // setEditId(data.id);
  } catch (error) {
    console.error("Fetch failed:", error);
  } finally {
    setLoading(false);
  }
};

  const handleEdit = (item) => {
    setFormState({ title: item.title, content: item.content });
    setEditId(item.id);
    setTab(1);
  };

 const handleSave = async () => {
  setFormLoading(true);
  try {
    const res = await fetch(`${url}auth/contact-form-content/${editId}`, {
      method: "POST", // or PUT/PATCH depending on backend
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formState),
    });

    if (!res.ok) throw new Error("Failed to update");

    await fetchFormItem(); // refresh
    setTab(0);
  } catch (err) {
    console.error(err);
  } finally {
    setFormLoading(false);
  }
};

  const columns = [
    { Header: "Title", accessor: "title" },
    // { Header: "Content", accessor: "content" },
    {
      Header: "Content",
      accessor: "content",
      Cell: ({ value }) => (
        <Tooltip title={value}>
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: 350,
            }}
          >
            {value}
          </div>
        </Tooltip>
      )
    },
    {
      Header: "Actions",
      accessor: "actions",
      Cell: ({ row }) => (
        <Button
          variant="contained"
          size="small"
          onClick={() => handleEdit(row.original)}
          sx={{ backgroundColor: "#183759", color: "#fff" }}
        >
          {/* Edit */}
          Modifica
        </Button>
      ),
    },
  ];

  const rows = [formItem]; // single-item array

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Backdrop open={loading || formLoading} sx={{ zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="#183759"
                borderRadius="lg"
              >
                <MDTypography variant="h6" color="white">
                  Form Settings
                </MDTypography>
              </MDBox>

              <Tabs value={tab} onChange={(e, val) => setTab(val)} variant="fullWidth">
                <Tab label="List" />
                {editId && <Tab label="Edit Item" />}
              </Tabs>

              {tab === 0 && (
                <MDBox pt={3}>
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={false}
                    entriesPerPage={{ defaultValue: 10 }}
                    showTotalEntries={false}
                    noEndBorder
                    currentPageIndex={currentPageIndex}
                    setCurrentPageIndex = {setCurrentPageIndex}
                  />
                </MDBox>
              )}

              {tab === 1 && (
                <MDBox pt={3} px={2}>
                  <Grid container justifyContent="center">
                    <Grid item xs={12} sm={8} md={6}>
                      <TextField
                        label="Title"
                        fullWidth
                        value={formState.title}
                        onChange={(e) =>
                          setFormState({ ...formState, title: e.target.value })
                        }
                        sx={{ mb: 2 }}
                      />
                      <TextField
                        label="Content"
                        fullWidth
                        multiline
                        rows={4}
                        value={formState.content}
                        onChange={(e) =>
                          setFormState({ ...formState, content: e.target.value })
                        }
                        sx={{ mb: 2 }}
                      />

                      <Button
                        variant="contained"
                        fullWidth
                        onClick={handleSave}
                        sx={{
                          mb: 5,
                          backgroundColor: "#183759",
                          color: "#fff",
                          "&:hover": { backgroundColor: "#204b80" },
                        }}
                      >
                        {/* Update */}
                        {editId ? "Aggiorna" : "Salva"}
                      </Button>
                    </Grid>
                  </Grid>
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default FormSettings;
